const IsNullOrEmpty = (string: string | null) => {
    return string == null || string.trim().length == 0;
}

export default IsNullOrEmpty;